/* eslint-env browser, es6 */
import m from "mithril";

interface WordListViewAttrs {
  wordList: [string, number][];
}

export class WordListView implements m.Component<WordListViewAttrs> {
  private wordList: [string, number][];

  constructor(vnode: m.Vnode<WordListViewAttrs>) {
    this.wordList = vnode.attrs.wordList;
  }

  view(): m.Children {
    return this.wordList.length === 0
      ? null
      : m(
          "div.wordlist",
          m(
            "ol",
            { reversed: true },
            this.wordList.map((wordScorePair) => {
              const [word, score] = wordScorePair;
              return m(
                "li",
                m("span.flex", [word, m("span.score", `(+${score})`)])
              );
            })
          )
        );
  }
}
